// Chakra imports
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Flex,
  Grid,
  Progress,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";

// Custom components
import IncreaseButton from "components/IncreaseBalance/index";
import { ToastContainer, toast } from 'react-toastify';
import Card from "components/Card/Card.js";
import BarChart from "components/Charts/BarChart";
import Chart from "components/Charts/Chart";
import IconBox from "components/Icons/IconBox";
// Custom icons
import {
  ProfileIcon,
  RocketIcon,
  GlobeIcon,
  WalletIcon,
} from "components/Icons/Icons.js";
import {
  FaLandmark,
} from "react-icons/fa";
import { RiCustomerServiceFill } from "react-icons/ri";

// Variables
import {
  barChartData,
  barChartOptions,
} from "variables/charts";
import { pageVisits, socialTraffic } from "variables/general";
import { getGlobal } from "config/global";
import list from "api/statistic/list";
import moment from 'moment-jalaali' 

export default function Dashboard() {
  let me = getGlobal("me")
const history = useHistory();

  // Chakra Color Mode
  const iconBlue = useColorModeValue("blue.500", "blue.500");
  const iconBoxInside = useColorModeValue("white", "white");
  const textColor = useColorModeValue("gray.700", "white");
  const tableRowColor = useColorModeValue("#F7FAFC", "navy.900");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const btnColor = useColorModeValue("navy.400", "navy.600");
  const textTableColor = useColorModeValue("gray.500", "white");
  const [data, setData] = useState()
  const [lineChart, setLineChart] = useState([])
  const [lineChartOption, setLineChartOption] = useState({})
  const [barChart, setBarChart] = useState([])
  const [barChartOption, setBarChartOption] = useState({})
  const { colorMode } = useColorMode();
  let token = localStorage.getItem('token')
  useEffect(() => {
    list().then((result) => {
      let data = result.data
      if(!data) return false;
      console.log(data)
      setData(data)
      let lineChartData = [
        {
          name: "بازدید از ایستگاه‌ها",
          data: [],
        },
        {
          name: "کلیک روی مارکرها",
          data: [],
        },
      ];
      let d = []
      for (let i = 0; i < 14; i++) {
        d.push(moment().add(i * -1, 'd').format("YYYY-MM-DDT00:00:00.000Z"))
      }
      d.forEach((item) => {
        let find1 = null
        let find2 = null
        data.daily.forEach((da) => {
          if (moment(da._id.date||"").format("YYYY-MM-DDT00:00:00.000Z") == item && da._id.type == 'station') {
            find1 = da
          }
          if (moment(da._id.date||"").format("YYYY-MM-DDT00:00:00.000Z") == item && da._id.type == 'marker') {
            find2 = da
          }
        })
        if (find1)
          lineChartData[0].data.push(find1.count)
        else
          lineChartData[0].data.push(0)
        if (find2)
          lineChartData[1].data.push(find2.count)
        else
          lineChartData[1].data.push(0)
      })
      lineChartData[0].data = lineChartData[0].data.reverse()
      lineChartData[1].data = lineChartData[1].data.reverse()
      setLineChart(lineChartData)
      let dark=(colorMode==="dark"?"dark":"light")
      let lineChartOptions = {
        chart: {
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        tooltip: {
          theme: dark,
          enabled: true,
          style: {
            colors: "#fff",
            fontSize: "12px",
            fontFamily: "IranianSansRegular,Tahoma"
          },
          marker: {
            show: true,
          },
        },
        xaxis: {
          type: "datetime",
          categories: [
            "امروز",
            "دیروز",
            moment().add(-2, 'd').format("jMM/jDD"),
            moment().add(-3, 'd').format("jMM/jDD"),
            moment().add(-4, 'd').format("jMM/jDD"),
            moment().add(-5, 'd').format("jMM/jDD"),
            moment().add(-6, 'd').format("jMM/jDD"),
            moment().add(-7, 'd').format("jMM/jDD"),
            moment().add(-8, 'd').format("jMM/jDD"),
            moment().add(-9, 'd').format("jMM/jDD"),
            moment().add(-10, 'd').format("jMM/jDD"),
            moment().add(-11, 'd').format("jMM/jDD"),
            moment().add(-12, 'd').format("jMM/jDD"),
            moment().add(-13, 'd').format("jMM/jDD"),
          ].reverse(),
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false,
          },
          labels: {
            style: {
              colors: "#fff",
              fontSize: "12px",
              fontFamily: "IranianSansRegular,Tahoma"
            },
          },
          tooltip: {
            enabled: true,
            style: {
              colors: "#fff",
              fontSize: "12px",
              fontFamily: "IranianSansRegular,Tahoma"
            },
            marker: {
              show: true,
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: "#fff",
              fontSize: "12px",
              fontFamily: "IranianSansRegular,Tahoma"
            },
          },
        },
        legend: {
          show: false,
        },
        grid: {
          strokeDashArray: 5,
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            shadeIntensity: 0.5,
            inverseColors: true,
            opacityFrom: 0.8,
            opacityTo: 0,
            stops: [],
          },
          colors: ["#fff", "#3182CE"],
        },
        colors: ["#dedede", "#3182CE"],
      };
      setLineChartOption(lineChartOptions)
      let tour_chart_data = [];
      data.group.forEach((item) => {
        if (item._id.type == 'station') {
          let last = tour_chart_data[item._id.tour] || 0
          tour_chart_data[item._id.tour] = item.count + last
        }
      })
      let barChartData = [
        {
          name: "بازدید",
          data: Object.values(tour_chart_data),
        },
      ];
      let barChartOptions = {
        chart: {
          toolbar: {
            show: false,
          },
        },
        tooltip: {
          theme: dark,
          enabled: true,
          style: {
            direction: 'rtl',
            colors: "#fff",
            fontSize: "12px",
            fontFamily: "IranianSansRegular,Tahoma"
          },
          marker: {
            show: true,
          },
        },
        xaxis: {
          categories: Object.keys(tour_chart_data),
          labels: {
            style: {
              colors: "#A0AEC0",
              fontSize: "12px",
              fontFamily: "IranianSansRegular,Tahoma"
            },
          },
          show: true,
          axisBorder: {
            show: false,
          },

        },
        yaxis: {
          show: true,
          color: "#A0AEC0",
          labels: {
            show: true,
            style: {
              colors: "#A0AEC0",
              fontSize: "14px",
              fontFamily: "IranianSansRegular,Tahoma"
            },
          },
        },
        fill: {
          colors: "#ED8936",
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          strokeDashArray: 5,
        },
        plotOptions: {
          bar: {
            borderRadius: 15,
            columnWidth: "15px",
          },
        },
        responsive: [
          {
            breakpoint: 768,
            options: {
              plotOptions: {
                bar: {
                  borderRadius: 0,
                },
              },
            },
          },
        ],
      };
      setBarChart(barChartData)
      setBarChartOption(barChartOptions)
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
    })
  }, [colorMode])
  if (!token) {
    window.location = "/auth/signIn";
    return (<div></div>)
  } else
    return (
      <Flex flexDirection='column' pt={{ base: "120px", md: "75px" }}>
        <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing='24px' mb='20px'>
          <Card minH='125px'>
            <Flex direction='column'>
              <Flex
                flexDirection='row'
                align='center'
                justify='center'
                w='100%'
                mb='25px'>
                <Stat me='auto'>
                  <StatLabel
                    fontSize='xs'
                    color='gray.400'
                    fontWeight='bold'
                    textTransform='uppercase'>
                    بازدید کننده ماهانه (نمایشگاه)
                  </StatLabel>
                  <Flex>
                    <StatNumber fontSize='lg' color={textColor} >
                      {
                        data && (() => {
                          let d = data.total.filter(item => item._id.type == 'station' && moment(item._id.date) > moment().add(-32, 'd'))
                          if (d.length > 0)
                            return <>{d[0].count}</>
                          else
                            return <>0</>
                        })()
                      }
                    </StatNumber>
                  </Flex>
                </Stat>
                <IconBox
                  borderRadius='50%'
                  as='box'
                  h={"45px"}
                  w={"45px"}
                  bg={iconBlue}>
                  <GlobeIcon h={"24px"} w={"24px"} color={iconBoxInside} />
                </IconBox>
              </Flex>
              <Text color='gray.400' fontSize='sm'>
                
                  {
                    data && (() => {
                      let now = data.total.filter(item => item._id.type == 'station' && moment(item._id.date) > moment().add(-32, 'd'))
                      let old = data.total.filter(item => item._id.type == 'station' && moment(item._id.date) < moment().add(-32, 'd'))
                      if (now.length > 0 && old.length > 0) {
                        let a = old[0].count
                        let b = now[0].count
                        let p = ((b - a) / Math.abs(a) * 100)
                        console.log(p)
                        return <span dir="rtl">{((p > 0) ? 
                          <Text as='span' color='green.400'>
                          {Math.abs(Math.round(p))+"% بیشتر از  ماه پیش"} 
                          </Text>: (p < 0) ? <Text as='span' color='red.400'>
                            {Math.abs(Math.round(p))+"% کمتر از  ماه پیش"}
                          </Text>
                           : 
                           <Text as='span' color='blue.400'>
                           "برابر با  ماه پیش"
                           </Text>)}</span>
                      }
                      else
                        return <>-</>
                    })()
                  }
                 
              </Text>
            </Flex>
          </Card>
          <Card minH='125px'>
            <Flex direction='column'>
              <Flex
                flexDirection='row'
                align='center'
                justify='center'
                w='100%'
                mb='25px'>
                <Stat me='auto'>
                  <StatLabel
                    fontSize='xs'
                    color='gray.400'
                    fontWeight='bold'
                    textTransform='uppercase'>
                    بازدید کننده ماهانه (فرود)
                  </StatLabel>
                  <Flex>
                    <StatNumber fontSize='lg' color={textColor}>
                    {
                        data && (() => {
                          let d = data.total_landing.filter(item => item._id.type == 'landing' && moment(item._id.date) > moment().add(-32, 'd'))
                          if (d.length > 0)
                            return <>{d[0].count}</>
                          else
                            return <>0</>
                        })()
                      }
                    </StatNumber>
                  </Flex>
                </Stat>
                <IconBox
                  borderRadius='50%'
                  as='box'
                  h={"45px"}
                  w={"45px"}
                  bg={iconBlue}>
                  <FaLandmark h={"45px"} w={"45px"} color={iconBoxInside} />
                </IconBox>
              </Flex>
              <Text color='gray.400' fontSize='sm'>
              {
                    data && (() => {
                      let now = data.total_landing.filter(item => item._id.type == 'landing' && moment(item._id.date) > moment().add(-32, 'd'))
                      let old = data.total_landing.filter(item => item._id.type == 'landing' && moment(item._id.date) < moment().add(-32, 'd'))
                      
                      if (now.length > 0 && old.length > 0) {
                        let a = old[0].count
                        let b = now[0].count
                        let p = ((b - a) / Math.abs(a) * 100)
                        console.log(p)
                        return <span dir="rtl">{((p > 0) ? 
                          <Text as='span' color='green.400'>
                          {Math.abs(Math.round(p))+"% بیشتر از  ماه پیش"} 
                          </Text>: (p < 0) ? <Text as='span' color='red.400'>
                            {Math.abs(Math.round(p))+"% کمتر از  ماه پیش"}
                          </Text>
                           : 
                           <Text as='span' color='blue.400'>
                           "برابر با  ماه پیش"
                           </Text>)}</span>
                      }
                      else
                        return <>-</>
                    })()
                  }
              </Text>
            </Flex>
          </Card>
          <Card minH='125px'>
            <Flex direction='column'>
              <Flex
                flexDirection='row'
                align='center'
                justify='center'
                w='100%'
                mb='25px'>
                <Stat me='auto'>
                  <StatLabel
                    fontSize='xs'
                    color='gray.400'
                    fontWeight='bold'
                    textTransform='uppercase'>
                    موجودی
                  </StatLabel>
                  <Flex>
                    <StatNumber fontSize='lg' color={textColor} >
                      {(me?.balance ?  (+me?.balance).toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0) + " تومان"}
                    </StatNumber>
                  </Flex>
                </Stat>
                <IconBox
                  borderRadius='50%'
                  as='box'
                  h={"45px"}
                  w={"45px"}
                  bg={iconBlue}>
                  <WalletIcon h={"24px"} w={"24px"} color={iconBoxInside} />
                </IconBox>
              </Flex>
              <Text fontSize='sm'>
                <Text as='span' color='gray.100' >
                <IncreaseButton />
                </Text>
              </Text>
            </Flex>
          </Card>
          <Card minH='125px'>
            <Flex direction='column'>
              <Flex
                flexDirection='row'
                align='center'
                justify='center'
                w='100%'
                mb='25px'>
                <Stat me='auto'>
                  <StatLabel
                    fontSize='xs'
                    color='gray.400'
                    fontWeight='bold'
                    textTransform='uppercase'>
                    باقی مانده از {me?.plan?.title || "پایه"}
                  </StatLabel>
                  <Flex>
                    <StatNumber fontSize='lg' color={textColor} >
                      {(me.expireIn ? (moment().diff(moment(me.expireIn), 'days') * -1) + " روز" : "بدون محدودیت")}
                    </StatNumber>
                  </Flex>
                </Stat>
                <IconBox
                  borderRadius='50%'
                  as='box'
                  h={"45px"}
                  w={"45px"}
                  bg={iconBlue}>
                  <RocketIcon h={"24px"} w={"24px"} color={iconBoxInside} />
                </IconBox>
              </Flex>
              <Text color='gray.400' fontSize='sm'>
                از {" "}
                <Text as='span' color='green.400'>
                  {me?.plan?.duration&&me?.plan?.duration>0 ? me?.plan?.duration : "نامحدود"}{" "}
                </Text>
                روز
              </Text>
            </Flex>
          </Card>
        </SimpleGrid>
        <Grid
          templateColumns={{ sm: "1fr", lg: "2fr 1fr" }}
          templateRows={{ lg: "repeat(2, auto)" }}
          gap='20px'>
          <Card
            bg={
              colorMode === "dark"
                ? "navy.800"
                : "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
            }
            p='0px'
          >
            <Flex direction='column' mb='40px' p='28px 22px 0px 0px'>
              <Text color='#fff' fontSize='lg' fontWeight='bold' mb='6px'>
                بازدید روزانه
              </Text>
              <Text color='#fff' fontSize='sm'>
                <Text as='span' color='green.400' fontWeight='bold'>
                  تجمیع نمایشگاه‌ها
                </Text>

              </Text>
            </Flex>
            <Box minH='300px'>
              {(lineChart) ?
                <Chart
                  type="area"
                  chartData={lineChart}
                  chartOptions={lineChartOption}
                />
                : ""
              }
            </Box>
          </Card>
          <Card p='0px'>
            <Flex direction='column' mb='40px' p='28px 22px 0px 0px'>
              <Text color='gray.400' fontSize='lg' fontWeight='bold' mb='6px'>
                بازدیدها
              </Text>
              <Text color={textColor} fontSize='sm' fontWeight='bold'>
                به تفکیک نمایشگاه
              </Text>
            </Flex>
            <Box minH='300px'>
              <Chart type="bar" chartData={barChart} chartOptions={barChartOption} />
            </Box>
          </Card>
          <Card p='0px'>
            <Flex direction='column' minH={"300px"}>
              <Flex align='center' justify='space-between' p='22px'>
                <Text fontSize='lg' color={textColor} fontWeight='bold'>
                  پر بازدیدترین ایستگاه‌ها
                </Text>

              </Flex>
              <Box overflow={{ sm: "hidden", lg: "hidden" }}>
                <Table>
                  <Thead>
                    <Tr bg={tableRowColor}>
                      <Th color='gray.400' borderColor={borderColor}>
                        نام ایستگاه
                      </Th>
                      <Th color='gray.400' borderColor={borderColor}>
                        نام نمایشگاه‌ها
                      </Th>
                      <Th color='gray.400' borderColor={borderColor}>
                        بازدید
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {data && data.group.filter((item) => item._id.type == "station").map((el, index, arr) => {
                      if (index > 10) return
                      return (
                        <Tr key={index}>
                          <Td
                            color={textTableColor}
                            fontSize='sm'
                            fontWeight='bold'
                            borderColor={borderColor}
                            border={index === arr.length - 1 ? "none" : null}>
                            {el._id.room}
                          </Td>
                          <Td
                            color={textTableColor}
                            fontSize='sm'
                            border={index === arr.length - 1 ? "none" : null}
                            borderColor={borderColor}>
                            {el._id.tour}
                          </Td>
                          <Td
                            color={textTableColor}
                            fontSize='sm'
                            border={index === arr.length - 1 ? "none" : null}
                            borderColor={borderColor}>
                            {el.count}
                          </Td>

                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              </Box>
            </Flex>
          </Card>
          <Card p='0px'>
            <Flex  direction='column'>
              <Flex align='center' justify='space-between' p='22px'>
                <Text fontSize='lg' color={textColor} fontWeight='bold'>
                  بازدید صفحه فرود
                </Text>

              </Flex>
            </Flex>
            <Box  overflow={{ sm: "hidden", lg: "hidden" }}>
              <Table>
                <Thead>
                  <Tr bg={tableRowColor}>
                    <Th color='gray.400' borderColor={borderColor}>
                      نام نمایشگاه
                    </Th>
                    <Th color='gray.400' borderColor={borderColor}>
                      بازدید                     
                      </Th>
                  </Tr>
                </Thead>
                <Tbody>
                {data && data.group_landing.filter((item) => item._id.type == "landing").map((el, index, arr) => {
                    return (
                      <Tr key={index}>
                        <Td
                          color={textTableColor}
                          fontSize='sm'
                          fontWeight='bold'
                          borderColor={borderColor}
                          border={index === arr.length - 1 ? "none" : null}>
                          {el._id.tour}
                        </Td>
                        <Td
                          color={textTableColor}
                          fontSize='sm'
                          borderColor={borderColor}
                          border={index === arr.length - 1 ? "none" : null}>
                          {el.count}
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </Box>
          </Card>
        </Grid>
      </Flex>
    );
}
